import SupervisorAccountIcon from '@material-ui/icons/SupervisorAccount';

import AdminList from './list';
import AdminShow from './show';
import AdminCreate from './create';
import AdminEdit from './edit';

export default {
    list: AdminList,
    show: AdminShow,
    create: AdminCreate,
    edit: AdminEdit,
    icon: SupervisorAccountIcon
};